module.exports = __webpack_public_path__ + "static/media/pinCluster.c3f4b6aa.svg";